import React from "react";

function Check_Icon(props) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="36" height="36" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0" transform="scale(0.0277778)" />
        </pattern>
        <image
          id="image0"
          width="36"
          height="36"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAACB0lEQVRIx93WsS9eYRTH8UOpBIlUGCUSq7WDodFJGkKi/4A2/gCLNBGDpEwE7dDqzEp16WAS/gcLHTCRdsDSiU8Hj+u973vvW0k7OXc65/zyfc495z7PcyMev+n1surprchO2bFkSOPfQXOqba4ge2JW+/8A3cJG64Em7Nq157oQ1GXcqrMst6Khfl1rxRWl7FMTGWxdUzlmIYkuikERETptJtVSGWY4CTa8LwdFaPQF3BgrSrc4AlsaU2tLQBERtsGZ1trUDPipO5tRPdAzp2C6OtHgGLypmOBEAaDHh9smmwTnVS03kOpprjvTHj+wpSlCc6ppMC9ZBp8egOG35xERPoLFvGgHjDwI8yo35f287AD0Z/7r/EvWYiL0gcM86BJ0JO8dvt2jijAR2sBVHnQF2iIivEgfZkIVYyJ0gMs86BD0JW/+HlWGidAPDvLBfTCc+Xeo72WYCCNgJx9cBB8rIneoEkyEz2A5HxwEp5WzylDFmGa/wEA+3OQcTOai81UDr9g63oLjmgPOdKrpWS46lxt4tpl1p3pmakttTWffdpTaHcgTX8GRliLZmBvwpezSSaD3NlL3hstWXEqCTZ11QBdJtVBeepP1JDoz4WkJ6NbWop5psJJJz6wa11UIurZXdvjdy0edVKxcdk3WZItQ7WYz2L+AIiI0GrJkx1RFrO6PxqO1P4rxP8x43ZXCAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
}

export default Check_Icon;
